import React, { useState, useEffect } from 'react'
import {
  ButtonGroup,
  CheckPicker,
  Col,
  ControlLabel,
  Icon,
  IconButton,
  Input,
  InputGroup,
  Message,
  Panel,
  Row,
  SelectPicker,
  Uploader,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { isImageOrPdf, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import notification from '../../utils/notification'
import { cloneDeep, isEmpty } from 'lodash-es'
import { getValueFromOptions } from '../../utils/dataUtil'

export default function InnovationView(props) {
  const {
    index,
    itemValue,
    onSubmit = () => {},
    onPreview = () => {},
    onDownload = () => {},
    onDelete = () => {},
    isSuccess,
  } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [formSchema, setFormSchema] = useState(props.schema)
  const [creatorValue, setCreatorValue] = useState([])
  const [fileTypeError, setFileTypeError] = useState(false)
  const [fileCountError, setFileCountError] = useState(false)
  const [filesImage, setFilesImage] = useState(null)
  const [fileList, setFileList] = useState([])

  const rowStyle = { marginTop: 8 }
  const rowColor = '#2da888'

  useEffect(() => {
    console.log('itemValue?.id => ', itemValue?.id)

    setFilesImage(itemValue.attachFiles)
    // const countValues = formSchema?.values?.length || 0

    let newArr = []
    if (itemValue?.creator?.length > 0) {
      itemValue.creator.map((item, index) => {
        newArr.push(item)
      })
    } else {
      newArr.push('')
    }

    setCreatorValue(newArr)
  }, [itemValue])

  useEffect(() => {
    console.log('isSuccess => ', isSuccess)
    if (isSuccess) {
      setFileList([])
    }
  }, [isSuccess])

  const addItemCreator = () => {
    const x = cloneDeep(creatorValue)

    let newArr = x || []
    newArr.push('')

    setCreatorValue(newArr)
  }

  const deleteItemCreator = (index, indexCreator) => {
    console.log('deleteItemCreator ', indexCreator)

    const x = cloneDeep(creatorValue)
    x.splice(indexCreator, 1)

    setCreatorValue(x)
  }

  const setValueCreator = (index, indexCreator, value) => {
    // console.log(indexCreator, value)
    const x = cloneDeep(creatorValue)
    // console.log('xdata => ', x)

    x[indexCreator] = value
    // console.log('value => ', x)

    setCreatorValue(x)
  }

  const tableAttachFiles = (files) => {
    return (
      <table width={'100%'} border={1}>
        <thead>
          <tr>
            <th width="10%" style={{ textAlign: 'center' }}>
              <p style={{ padding: 3 }}>ลำดับ</p>
            </th>
            <th width="75%">
              <p style={{ padding: 3 }}>{`ไฟล์ (รวม ${filesImage?.length} ไฟล์)`}</p>
            </th>
            <th width="15%">
              <p style={{ padding: 3 }}>#</p>
            </th>
          </tr>
        </thead>
        <tbody>
          {filesImage?.map((item, index) => {
            return (
              <tr>
                <td align="center">{index + 1}</td>
                <td>
                  <p style={{ padding: 3 }}>{item.label}</p>
                </td>
                <td align="center">
                  <div style={{ padding: 3 }}>
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        size="sm"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={() => onPreview(item)}
                        // disabled={!item?.path}
                      />
                      <IconButton
                        appearance="ghost"
                        size="sm"
                        icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                        onClick={() => onDownload(item)}
                        // disabled={!item?.path}
                      />
                      {/* <IconButton
                        appearance="ghost"
                        size="sm"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                        onClick={() => onDelete(item)}
                        // disabled={!item?.path}
                      /> */}
                    </ButtonGroup>
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  const convertArrayToStringInline = (strArray) => {
    let str = ''
    if (strArray?.length > 0) {
      strArray.map((item, index) => {
        console.log('item => ', item)
        str += `${index + 1}. ${item} <br />`
      })

      return str
    }

    return ''
  }

  return (
    <Panel
      // shaded
      collapsible
      defaultExpanded
      header={`${formSchema?.header || ''}ที่ ${index + 1} `}
      bordered
      key={index}
      style={{ marginBottom: 10 }}
    >
      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.name.label} : </b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {itemValue.name}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.detail.label} : </b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {itemValue.detail}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.innovationType.label} : </b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {itemValue?.innovationType || ''}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={{ marginTop: 15 }}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.issue.label} : </b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <div dangerouslySetInnerHTML={{ __html: convertArrayToStringInline(itemValue?.issue) }} />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={{ marginTop: 15 }}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.target.label} : </b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <div
            dangerouslySetInnerHTML={{ __html: convertArrayToStringInline(itemValue?.target) }}
          />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={{ marginTop: 15 }}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.creator.label} : </b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <div dangerouslySetInnerHTML={{ __html: convertArrayToStringInline(creatorValue) }} />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={{ marginTop: 15 }}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.yearOfDevelopment.label} : </b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {itemValue?.yearOfDevelopment?.toString() || ''}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.attachFiles.header} : </b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          <br />

          {filesImage?.length > 0 && <div style={{ marginTop: 10 }}>{tableAttachFiles()}</div>}

          <br />
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.utilization.label} : </b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {getValueFromOptions(formSchema.input.utilization.options, itemValue.utilization) || ''}
          <br />
          {itemValue.utilizationDetail && (
            <>
              <div style={{ marginTop: 5 }}>
                <b style={{ color: 'black' }}>{formSchema.input.utilizationDetail.label}</b>
                <br />
                {`  - ${itemValue.utilizationDetail}`}
              </div>
            </>
          )}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.trlLevel.label} :</b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {getValueFromOptions(formSchema.input.trlLevel.options, itemValue.trlLevel) || ''}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.slrLevel.label} :</b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {getValueFromOptions(formSchema.input.slrLevel.options, itemValue.slrLevel) || ''}
          {/* {itemValue.slrLevel || ''} */}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.detailMore.label} :</b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {itemValue.detailMore || '-ไม่ระบุ-'}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={24} md={24} sm={24} xs={24}>
          <hr />
          <p style={{ color: '#2da888', marginLeft: 15 }}>{formSchema.contactChannels.title}</p>
        </Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.contactChannels.fullName.label} :</b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {itemValue.fullName || ''}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.contactChannels.email.label} :</b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {itemValue.email || ''}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.contactChannels.telephone.label} :</b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {itemValue.telephone || ''}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.contactChannels.agency.label} :</b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {itemValue.agency || ''}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={24} md={24} sm={24} xs={24}>
          <hr />
          <p style={{ color: '#2da888', marginLeft: 15 }}>{formSchema.evaluationTitile}</p>
        </Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.criteria1.label} :</b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {getValueFromOptions(
            formSchema.input.criteria1.options,
            itemValue.criteria1.toString()
          ) || '-ไม่ระบุ-'}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row style={rowStyle}>
        <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
          <b>{formSchema.input.criteria3.label} :</b>
        </Col>
        <Col lg={16} md={16} sm={16} xs={16}>
          {getValueFromOptions(
            formSchema.input.criteria3.options,
            itemValue.criteria3.toString()
          ) || '-ไม่ระบุ-'}
        </Col>
        <Col lg={2} md={2} sm={2} xs={2}></Col>
      </Row>

      <Row>
        <Col lg={24} md={24} sm={24} xs={24} style={{ marginBottom: 10, marginTop: 10 }}>
          {itemValue.typeSendFlag && itemValue.strSendFlag && (
            <div>
              <Message
                showIcon
                type={itemValue.typeSendFlag}
                // title={itemValue.strSendFlag}
                description={itemValue.strSendFlag}
              />
            </div>
          )}
        </Col>
      </Row>
    </Panel>
  )
}
